import { HttpMethod, apiRequest } from './api'
import type { ApiResponse, PaginatedResponse } from './api'

// 分页筛选查询地区及宿舍
export async function getRegions(
  params?: RegionQueryParams,
): Promise<ApiResponse<PaginatedResponse<Region>>> {
  const searchParams = new URLSearchParams()

  if (params) {
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        searchParams.append(key, String(value))
      }
    })
  }

  const queryString = searchParams.toString()
  const endpoint = queryString ? `/region?${queryString}` : '/region'

  return apiRequest<PaginatedResponse<Region>>(endpoint, {
    method: HttpMethod.GET,
  })
}

// 查询所有地区
export async function getAllRegions(): Promise<
  ApiResponse<Array<RegionListItem>>
> {
  return apiRequest<Array<RegionListItem>>('/region/getAll', {
    method: HttpMethod.GET,
  })
}

// 添加地区
export async function addRegion(
  data: RegionCreateRequest,
): Promise<ApiResponse<number>> {
  return apiRequest<number>('/region/add', {
    method: HttpMethod.POST,
    body: data,
  })
}

// 修改地区
export async function updateRegion(
  data: RegionUpdateRequest,
): Promise<ApiResponse<boolean>> {
  return apiRequest<boolean>('/region/update', {
    method: HttpMethod.POST,
    body: data,
  })
}

// 删除地区
export async function deleteRegion(id: number): Promise<ApiResponse<boolean>> {
  return apiRequest<boolean>(`/region/delete?id=${id}`, {
    method: HttpMethod.POST,
  })
}

// 地区类型
export interface Region {
  id: number
  name: string
  singlePrice: number
  introduction: string
}

// 地区列表查询响应（用于getAll接口）
export interface RegionListItem {
  id: number
  name: string
  delFlag: number
}

// 地区查询参数
export interface RegionQueryParams {
  id?: string
  name?: string
  singlePrice?: string
  introduction?: string
  pageNum?: number
  pageSize?: number
}

// 地区创建请求
export interface RegionCreateRequest {
  name: string
  singlePrice: string
  introduction: string
}

// 地区更新请求
export interface RegionUpdateRequest {
  id: number
  name: string
  singlePrice: string
  introduction: string
}
